'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled, { css } from 'styled-components';
import { paragraph, body, label, title, headline, display } from './const.js';

var typoStyles = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var name = _a.name, size = _a.size;
    switch (name) {
        case 'display':
            return function () {
                switch (size) {
                    case 'large':
                        return display.large;
                    case 'medium':
                        return display.medium;
                    case 'small':
                        return display.small;
                }
            };
        case 'headline':
            return function () {
                switch (size) {
                    case 'large':
                        return headline.large;
                    case 'medium':
                        return headline.medium;
                    case 'small':
                        return headline.small;
                }
            };
        case 'title':
            return function () {
                switch (size) {
                    case 'extraLarge':
                        return title.extraLarge;
                    case 'large':
                        return title.large;
                    case 'medium':
                        return title.medium;
                    case 'small':
                        return title.small;
                }
            };
        case 'label':
            return function () {
                switch (size) {
                    case 'large':
                        return label.large;
                    case 'medium':
                        return label.medium;
                    case 'small':
                        return label.small;
                }
            };
        case 'body':
            return function () {
                switch (size) {
                    case 'large':
                        return body.large;
                    case 'medium':
                        return body.medium;
                    case 'small':
                        return body.small;
                }
            };
        case 'paragraph':
            return function () {
                switch (size) {
                    case 'large':
                        return paragraph.large;
                    case 'medium':
                        return paragraph.medium;
                    case 'small':
                        return paragraph.small;
                }
            };
    }
});
var Typo = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    font-family: ", ", Arial, sans-serif;\n    font-style: normal;\n    margin: 0;\n    padding: 0;\n    ", "\n"], ["\n    color: ", ";\n    font-family: ", ", Arial, sans-serif;\n    font-style: normal;\n    margin: 0;\n    padding: 0;\n    ", "\n"])), function (_a) {
    var color = _a.color;
    return color;
}, function (_a) {
    var fontFamily = _a.fontFamily;
    return fontFamily;
}, typoStyles);
var templateObject_1, templateObject_2;

export { Typo, typoStyles };
//# sourceMappingURL=styled.css.js.map
